export const UXFB_VISITED_PROJECTS_COOKIE = 'uxfb_visited_projects';

export const MAX_VISITED_PROJECTS_COUNT_FOR_UXFB = 3;
